import axios from 'axios';
import { API, API_URL } from '../constants';
import { getLocalStorageByKey } from '../utils/localStorage';

export const getMLTaskList = () => {
  return async dispatch => {
    return await axios({
      method: 'GET',
      url: API_URL + API.GET.ML.TASK_LIST,
      headers: { Authorization: 'Bearer ' + getLocalStorageByKey('token') },
    })
      .then(response => {
        const { data, status } = response;
        return { data, status };
      })
      .catch(error => {
        const { status } = error.response;
        return { data: {}, status };
      });
  };
};

export const fetchMLData = () => {
  return async dispatch => {
    return await axios({
      method: 'GET',
      url: API_URL + API.GET.ML.FETCH_DATA,
      headers: { Authorization: 'Bearer ' + getLocalStorageByKey('token') },
    })
      .then(response => {
        const { data, status } = response;
        return { data, status };
      })
      .catch(error => {
        const { status } = error.response;
        return { data: {}, status };
      });
  };
};

export const checkMLTask = () => {
  return async dispatch => {
    return await axios({
      method: 'GET',
      url: API_URL + API.GET.ML.CHECK_LIST,
      headers: { Authorization: 'Bearer ' + getLocalStorageByKey('token') },
    })
      .then(response => {
        const { data, status } = response;
        return { data, status };
      })
      .catch(error => {
        const { status } = error.response;
        return { data: {}, status };
      });
  };
};

export const checkPredictMLTask = mlTaskId => {
  return async dispatch => {
    return await axios({
      method: 'GET',
      url: API_URL + API.GET.ML.CHECK_PREDICT_TASK.replace(':taskId', mlTaskId),
      headers: { Authorization: 'Bearer ' + getLocalStorageByKey('token') },
    })
      .then(response => {
        const { data, status } = response;
        return { data, status };
      })
      .catch(error => {
        const { status } = error.response;
        return { data: {}, status };
      });
  };
};

export const sendPredictUsersProjects = projectId => {
  return async dispatch => {
    return await axios({
      method: 'POST',
      url: API_URL + API.POST.ML.PREDICT_USERS_PROJECTS,
      headers: { Authorization: 'Bearer ' + getLocalStorageByKey('token') },
      data: { projectId },
    })
      .then(response => {
        const { data, status } = response;
        return { data, status };
      })
      .catch(error => {
        const { status } = error.response;
        return { data: {}, status };
      });
  };
};

export const sendPredictProjectsUser = () => {
  return async dispatch => {
    return await axios({
      method: 'POST',
      url: API_URL + API.POST.ML.PREDICT_PROJECTS_USER,
      headers: { Authorization: 'Bearer ' + getLocalStorageByKey('token') },
    })
      .then(response => {
        const { data, status } = response;
        return { data, status };
      })
      .catch(error => {
        const { status } = error.response;
        return { data: {}, status };
      });
  };
};
